var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartplus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon icon-tabler icons-tabler-outline icon-tabler-shopping-cart-plus",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17h-6.5v-14h-2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5l14 1l-.86 6.017m-2.64 .983h-10.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19h6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16v6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartplus);
export default __webpack_public_path__ + "static/media/cartplus.c3d2c258f612278bbcd8dcc09f5576b7.svg";
export { ForwardRef as ReactComponent };